var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center h-100",style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('edit-icon',{staticClass:"ml-3 hover:text-primary cursor-pointer",attrs:{"size":"1.3x"},on:{"click":_vm.Edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }